/**
 * Inactivity warning shown shortly before an idle auto-logout (Bug-0022).
 * Shared by the staff workbench (Layout) and the candidate portal
 * (PortalShell). Self-contained overlay so it works in both apps.
 */

import { Button } from './ui/Button';

export function IdleWarningModal({
  secondsLeft,
  onStay,
  onSignOut,
}: {
  secondsLeft: number;
  onStay: () => void;
  onSignOut: () => void;
}) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="idle-warning-title"
      className="fixed inset-0 flex items-center justify-center bg-[var(--color-ink)]/50 px-4"
      style={{ zIndex: 9999 }}
    >
      <div className="w-full max-w-[400px] rounded-[6px] border border-[var(--color-rule)] bg-[var(--color-surface)] p-6 shadow-lg">
        <p className="eyebrow mb-2">Session</p>
        <h2
          id="idle-warning-title"
          className="text-[20px] font-semibold tracking-tight text-[var(--color-ink)]"
        >
          Still there?
        </h2>
        <p className="mt-3 font-sans text-[14px] leading-relaxed text-[var(--color-ink-soft)]">
          For your security, you'll be signed out in{' '}
          <strong className="font-mono tabular-nums text-[var(--color-ink)]">
            {secondsLeft}s
          </strong>{' '}
          due to inactivity.
        </p>
        <div className="mt-6 flex justify-end gap-2">
          <Button variant="secondary" size="sm" onClick={onSignOut}>
            Sign out
          </Button>
          <Button variant="primary" size="sm" onClick={onStay}>
            Stay signed in
          </Button>
        </div>
      </div>
    </div>
  );
}
